// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2XZyj","options":"AnswerScale_options__31rz_","selected":"AnswerScale_selected__3-K35"};